<div
    class="cmps-cdk-border-radius-4px cmps-cdk-bg-color-white cmps-uik-box-shadow-200 cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-flex-column"
>
    <cmps-radio-group
        [ngModel]="_state.viewParams.reportType"
        (ngModelChange)="_state.viewParams.reportType = $event; _onChange()"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-cg-0dot5">
            <cmps-radio [value]="_ReportType.Role">Role</cmps-radio>
            <cmps-radio [value]="_ReportType.Team">Team</cmps-radio>
            <cmps-radio [value]="_ReportType.Individual">Individual</cmps-radio>
        </div>
    </cmps-radio-group>

    <cmps-population-select
        [canSelectRole]="true"
        [selectedPopulation]="_Population.Role"
        [singlePopulationSelect]="true"
        [selectableRoleIds]="_state.selectableRoleIds"
        [selection]="_state.viewParams.role"
        (selectionChange)="_state.viewParams.role = $event; _onChange()"
        (selectionLabelChange)="_onRoleLabelChange($event)"
        *ngIf="_state.viewParams.reportType === _ReportType.Role"
    ></cmps-population-select>

    <cmps-population-select
        [canSelectTeam]="true"
        [selectedPopulation]="_Population.Team"
        [singlePopulationSelect]="true"
        [selection]="_state.viewParams.team"
        (selectionChange)="_state.viewParams.team = $event; _onChange()"
        (selectionLabelChange)="_onTeamLabelChange($event)"
        *ngIf="_state.viewParams.reportType === _ReportType.Team"
    ></cmps-population-select>

    <cmps-population-select
        [canSelectUser]="true"
        [selectedPopulation]="_Population.User"
        [singlePopulationSelect]="true"
        [selection]="_state.viewParams.individual"
        (selectionChange)="_state.viewParams.individual = $event; _onChange()"
        (selectionLabelChange)="_onIndividualLabelChange($event)"
        *ngIf="_state.viewParams.reportType === _ReportType.Individual"
    ></cmps-population-select>
</div>
